import React, { useEffect, useRef, useState } from 'react'
import Highcharts, { fireEvent, merge, Point, Series } from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import highcharts3d from 'highcharts/highcharts-3d'
import exporting from 'highcharts/modules/exporting'
exporting(Highcharts)
highcharts3d(Highcharts)

import { useDispatch, useSelector } from 'react-redux'
import { ChartConfig } from '../../Redux/VisualUnits/visualUnitStateSlice'
import { FoundationsEnums } from '../../enum'
import { getDistanceFromTop } from '../../Utils'
import FilterList from './filterList'
import { VisualUnitApiDTO_VisualUnit } from '../../Interfaces/APIContracts/VisualUnitApiDTO_VisualUnit'
import { RunVisualUnitWithId_VisualUnit } from '../../Interfaces/APIContracts/RunVisualUnitWithId_VisualUnit'

// Override default highcharts legend behavior to enable hovering on legend items for multiple pie charts
;import { getChartOptions } from './chartOptions'
import { getCurrentUserData, RootState } from '../../Redux/store'
(Highcharts.Legend as any).prototype.setItemEvents = function (
    item: {
        legendGroup: any
        legendSymbol: any
        chart: any
        legendItem: { [s: string]: any }
        series: { chart: { series: { points: { [x: string]: any } }[] } }
        index: string | number
        setVisible: () => void
        visible: any
        firePointEvent: (arg0: string, arg1: { browserEvent: any }) => void
    },
    legendLabel: { css: (arg0: any) => void },
    useHTML: any
) {
    const legend = this,
        legendItem = item.legendItem || {},
        boxWrapper = legend.chart.renderer.boxWrapper,
        isPoint = item instanceof Point,
        isSeries = item instanceof Series,
        activeClass = 'highcharts-legend-' + (isPoint ? 'point' : 'series') + '-active',
        styledMode = legend.chart.styledMode,
        // When `useHTML`, the symbol is rendered in other group, so
        // we need to apply events listeners to both places
        // legendElements = legend.allItems
        legendElements = useHTML ? [legendLabel, item.legendSymbol] : [item.legendGroup]
    const setOtherItemsState = (state: string, others: any[]) => {
        others.forEach((otherItem) => {
            if (otherItem.series.options?.type && item !== otherItem) {
                ;[otherItem].concat(otherItem.linkedSeries || []).forEach((otherItem_2) => {
                    otherItem_2.setState(state, !isPoint)
                })
            } else {
                otherItem.setState(state)
            }
        })
    }
    
    function setHover(item: {
        legendItem?: { [s: string]: any }
        series: any
        index?: string | number
        setVisible?: () => void
        visible: any
        firePointEvent?: (arg0: string, arg1: { browserEvent: any }) => void
        setState?: any
    }) {
        if (item.visible) {
            setOtherItemsState('inactive', item.series?.points || [])
        }
        item.setState('hover')
        // A CSS class to dim or hide other than the hovered
        // series.
        // Works only if hovered series is visible (#10071).
        if (item.visible) {
            boxWrapper.addClass(activeClass)
        }
        if (!styledMode) {
            legendLabel.css(legend.options.itemHoverStyle)
        }
    }

    function setMouseOut(item: {
        legendItem?: { [s: string]: any }
        series: any
        index?: string | number
        setVisible?: () => void
        visible: any
        firePointEvent?: (arg0: string, arg1: { browserEvent: any }) => void
        setState?: any
    }) {
        if (!legend.chart.styledMode) {
            legendLabel.css(merge(item.visible ? legend.itemStyle : legend.itemHiddenStyle))
        }
        setOtherItemsState('', item.series?.points || [])
        // A CSS class to dim or hide other than the hovered
        // series.
        boxWrapper.removeClass(activeClass)
        item.setState()
    }
    // Set the events on the item group, or in case of useHTML, the item
    // itself (#1249)
    for (const element of legendElements) {
        if (element) {
            element
                .on('mouseover', function () {
                    if (item.series !== undefined) {
                        for (let i = 0; i < item.series.chart.series.length; i++) {
                            if (item.series.chart.series[i].points[item.index]) {
                                setHover(item.series.chart.series[i].points[item.index])
                            }
                        }
                    } else {
                        item.chart.series.forEach(
                            (series: {
                                index: string | number
                                setState: (arg0: string) => void
                            }) => {
                                if (series.index !== item.index) {
                                    series.setState('inactive')
                                } else {
                                    series.setState('select')
                                }
                            }
                        )
                    }
                })
                .on('mouseout', function () {
                    const series =
                        item.series !== undefined ? item.series.chart.series : item.chart.series
                    if (item.series !== undefined) {
                        for (let i = 0; i < item.series.chart.series.length; i++) {
                            if (item.series.chart.series[i].points[item.index]) {
                                setMouseOut(item.series.chart.series[i].points[item.index])
                            }
                        }
                    } else {
                        item.chart.series.forEach(
                            (series: { setState: (arg0: string) => void }) => {
                                series.setState('normal')
                            }
                        )
                    }
                })
                .on('click', function (event: any) {

                    const defaultItemClick = function () {
                        const chartType = (item.series as Series)?.type;
                        if(chartType === 'pie'){
                           if (item.series !== undefined) {
                            for (let i = 0; i < item.series.chart.series.length; i++) {
                                const targetSeries = item.series.chart.series[i];
                                const targetPoint = targetSeries.points[item.index];
                                if (targetPoint && targetPoint.setVisible) {
                                    targetPoint.setVisible();
                                }
 
                            }
                           } 
                        }
                        else{
                               if (item.setVisible) {
                            item.setVisible()
                        }
                        if (item.series !== undefined) {
                            for (let i = 0; i < item.series.chart.series.length; i++) {
                                 if (
                                    item.index !== i &&
                                    item.series.chart.series[i].points[item.index]?.setVisible
                                ) {
                                    item.series.chart.series[i].points[item.index].setVisible()
                                }

                            }
                        }
                        }
                       
                        // Reset inactive state
                        setOtherItemsState(item.visible ? 'inactive' : '', [])
                    }
                    // A CSS class to dim or hide other than the hovered
                    // series. Event handling in iOS causes the activeClass
                    // to be added prior to click in some cases (#7418).
                    boxWrapper.removeClass(activeClass)
                    fireEvent(
                        legend,
                        'itemClick',
                        {
                            // Pass over the click/touch event. #4.
                            browserEvent: event,
                            legendItem: item,
                        },
                        defaultItemClick
                    )
                    // Deprecated logic
                    // Click the name or symbol
                    // if (isPoint) {
                    //     item.firePointEvent('legendItemClick', {
                    //         browserEvent: event,
                    //     })
                    // } else if (isSeries) {
                    //     fireEvent(item, 'legendItemClick', {
                    //         browserEvent: event,
                    //     })
                    // }
                })
        }
    }
}

interface chartProps {
    // report: VisualUnitApiDTO_VisualUnit
    vuId: number
    viewerType: number
    executeResult: RunVisualUnitWithId_VisualUnit
    chartConfig: ChartConfig
    updateChartConfig: (key: keyof ChartConfig, value: any) => void
    openDrillThru: (cellInfo: any, cell: any, row: any, rowIndex: any) => void
    // drillThruDpList?: { [s: string]: any }[]
    chartComponent: any,
    AllowDrillThru?:any
    // filterList: chartFilter[]
}

const ReportChart = (props: chartProps) => {
    const {
        vuId,
        // chartEl,
        viewerType,
        executeResult,
        chartConfig,
        updateChartConfig,
        openDrillThru,
        // drillThruDpList,
        chartComponent,
        // filterList,
        AllowDrillThru,
    } = props
    const currentUserData = useSelector((state: RootState) => getCurrentUserData(state))
    const chartWidthRef = useRef<HTMLDivElement>(null)
    // Firstrender is used to prevent the chart config useeffect from redrawing immediately
    const [firstRender, setFirstRender] = useState(true)
    const dragging = useRef(false)
    const sensitivity = 5
    const posX = useRef(0)
    const posY = useRef(0)
    const alpha = useRef(15)
    const beta = useRef(15)

    const [chartOptions, setChartOptions] = useState(
        getChartOptions(
            vuId || -1,
            // currentViewerType || -1,
            viewerType || -1,
            executeResult,
            chartConfig?.enable3dView,
            chartConfig?.isDrawing,
            chartConfig?.showLegend,
            chartWidthRef.current?.offsetWidth || 1,
            openDrillThru ||
                (() => {
                    console.error('Drillthrus on chart not defined')
                }),
            executeResult.drillThruDPList,
            currentUserData.type,
            alpha.current,
            beta.current
        )
    )
    const dispatch = useDispatch()

    //to display drill thru based on privilege only
    // Create and set chart Options
    useEffect(() => {
        if (viewerType !== FoundationsEnums.VisualUnitViewerType.Table && !firstRender) {
            if (
                pathGroup.current?.destroy !== undefined &&
                chartComponent?.current !== undefined &&
                Object.keys(chartComponent?.current).length !== 0
            ) {
                pathGroup.current.destroy()
                pathGroup.current = undefined
            }

            setChartOptions({
                ...getChartOptions(
                    vuId || -1,
                    // currentViewerType || -1,
                    viewerType || -1,
                    // newResultData,
                    executeResult,
                    chartConfig?.enable3dView,
                    chartConfig?.isDrawing,
                    chartConfig?.showLegend,
                    chartWidthRef.current?.offsetWidth || 1,
                    openDrillThru ||
                        (() => {
                            console.error('Drillthrus on chart not defined')
                        }),
                    executeResult.drillThruDPList,
                    currentUserData.type,
                    alpha.current,
                    beta.current
                ),
            })
        }
        if (firstRender) setFirstRender(false)
    }, [chartConfig])

    useEffect(() => {
        if (viewerType === FoundationsEnums.VisualUnitViewerType.Chart_Pie) {
            // if (currentViewerType !== FoundationsEnums.VisualUnitViewerType.Table && !firstRender) {
            setChartOptions({
                ...getChartOptions(
                    vuId || -1,
                    // currentViewerType || -1,
                    viewerType || -1,
                    // newResultData,
                    executeResult,
                    chartConfig?.enable3dView,
                    chartConfig?.isDrawing,
                    chartConfig?.showLegend,
                    chartWidthRef.current?.offsetWidth || 1,
                    openDrillThru ||
                        (() => {
                            console.error('Drillthrus on chart not defined')
                        }),
                    executeResult.drillThruDPList,
                    currentUserData.type,
                    alpha.current,
                    beta.current
                ),
            })
        }
    }, [chartWidthRef.current?.offsetWidth])

    useEffect(() => {
        if (chartComponent.current?.chart !== undefined) {
            // TODO handle redrawing path on fullscreen
            Highcharts.addEvent(chartComponent.current?.chart, 'redraw', resizePath)
        }
    }, [chartComponent.current?.chart])

    useEffect(() => {
        window.addEventListener('keydown', escapeFullScreen)

        return () => {
            window.removeEventListener('keydown', escapeFullScreen)
        }
    }, [])
    // toggle chart full screen
    useEffect(() => {
        if (chartComponent.current?.chart !== undefined && chartConfig?.isFullScreen) {
            chartComponent.current?.chart.fullscreen?.toggle()
            if (chartComponent.current?.chart.fullscreen == undefined) {
                console.error(
                    'Fullscreen not defined for highcharts, check if module imported correctly'
                )
            }
        }
    }, [chartConfig?.isFullScreen])

    // ============================================== Handle special chart events =======================================================
    const startingPlotHeight = useRef(chartComponent.current?.chart?.plotHeight || 0)
    const startingPlotWidth = useRef(chartComponent.current?.chart?.plotWidth || 0)
    const chartHeightRatio = useRef(1)
    const chartWidthRatio = useRef(1)
    const startCoordinate = useRef([] as any[])
    const drawingActive = useRef(false)

    const pathGroup = useRef(undefined as any)
    const resizePath = function () {
        if (chartConfig?.isDrawing && drawingActive.current) {
            chartHeightRatio.current =
                chartComponent.current?.chart?.plotHeight / startingPlotHeight.current
            chartWidthRatio.current =
                chartComponent.current?.chart?.plotWidth / startingPlotWidth.current
            pathGroup.current?.attr(
                'transform',
                `translate(${chartComponent.current?.chart?.plotLeft * (1 - chartWidthRatio.current)},${chartComponent.current?.chart?.plotTop * (1 - chartHeightRatio.current)}) scale(${chartWidthRatio.current},${chartHeightRatio.current})`
            )
        }
    }

    useEffect(() => {

        const handleFullscreenChange = () => {   // Define a handler that will be called whenever fullscreen mode changes
            if (!document.fullscreenElement) {   // Check if fullscreen mode has been exited (no element is fullscreen anymore)
                updateChartConfig('isFullScreen', false) // If fullscreen has exited, update the chart config to set isFullScreen = false
            }
        };
        document.addEventListener('fullscreenchange', handleFullscreenChange);
        return () => {
            document.removeEventListener('fullscreenchange', handleFullscreenChange);
        };

    }, []);

    const escapeFullScreen = (e: any) => {
        if (e.key === 'Escape' && chartConfig?.isFullScreen) {
            updateChartConfig('isFullScreen', false)
            chartComponent.current?.chart.fullscreen?.toggle()
        }
    }

    const chartStartPosition = (e: any) => {
        if (chartConfig?.enable3dView) {
            dragging.current = true
            if (chartComponent.current?.chart !== undefined) {
                const chartSettings = chartComponent.current?.chart?.pointer.normalize(e)
                posX.current = chartSettings.pageX
                posY.current = chartSettings.pageY
                alpha.current = chartComponent.current?.chart.options.chart.options3d.alpha
                beta.current = chartComponent.current?.chart.options.chart.options3d.beta
            }
        }
    }

    const chartMouseDown = (e: { target: any; pageX: number; pageY: number }) => {
        if (chartComponent.current?.chart !== undefined) {
            chartStartPosition(e)
            drawingActive.current = chartConfig?.isDrawing
            if (drawingActive.current) {
                const { offsetLeft } = chartComponent.current?.chart.container
                const distanceTop = getDistanceFromTop(chartComponent.current?.chart.container)
                const left =
                    (e.pageX - offsetLeft) / chartWidthRatio.current -
                    (chartComponent.current?.chart.plotLeft * (1 - chartWidthRatio.current)) /
                        chartWidthRatio.current
                const top =
                    (e.pageY - distanceTop) / chartHeightRatio.current -
                    (chartComponent.current?.chart.plotTop * (1 - chartHeightRatio.current)) /
                        chartHeightRatio.current
                startCoordinate.current = [left, top]

                if (pathGroup.current === undefined) {
                    pathGroup.current = chartComponent.current.chart.renderer
                        .g('customPathGroup')
                        .attr({
                            id: `${vuId}_pathGroup`,
                        })
                        .add()
                        .toFront()
                }
            }
        } else {
            console.error(
                'Chart reference not found, check order of rendering to make sure chart is defined correctly'
            )
        }
    }
    const changeChartAngle = (e: any) => {
        const chart = chartComponent.current?.chart
        const newBeta = beta.current + (posX.current - e.pageX) / sensitivity
        chart.options.chart.options3d.beta = newBeta
        const newAlpha = alpha.current + (e.pageY - posY.current) / sensitivity
        chart.options.chart.options3d.alpha = newAlpha
        if (chart && !chartConfig.isDrawing) chart.redraw(false)
    }

    const chartMove = (e: any) => {
        if (chartComponent.current?.chart !== undefined) {
            if (chartConfig?.enable3dView && dragging.current) {
                changeChartAngle(e)
            }
            if (chartConfig?.isDrawing && drawingActive.current) {
                const { offsetLeft } = chartComponent.current?.chart.container
                const left =
                    (e.pageX - offsetLeft) / chartWidthRatio.current -
                    (chartComponent.current?.chart.plotLeft * (1 - chartWidthRatio.current)) /
                        chartWidthRatio.current
                const distanceTop = getDistanceFromTop(chartComponent.current?.chart.container)
                const top =
                    (e.pageY - distanceTop) / chartHeightRatio.current -
                    (chartComponent.current?.chart.plotTop * (1 - chartHeightRatio.current)) /
                        chartHeightRatio.current
                // drawingPaths.push([startCoordinate[0], startCoordinate[1], left, top]);
                chartComponent.current?.chart.renderer
                    .path(['M', ...startCoordinate.current, 'L', left, top])
                    .attr({
                        'stroke-width': 3,
                        stroke: 'orange',
                    })
                    .addClass('chartDrawing')
                    .add(pathGroup.current)
                    .toFront()
                startCoordinate.current = [left, top]
            }
        } else {
            console.error(
                'Chart reference not found, check order of rendering to make sure chart is defined correctly'
            )
        }
    }
    // ============================================== End special chart events =======================================================
    // TODO add data_explore and date_tempViewerType code

    return (
        <div id={'vu_chart_wrapper_' + vuId} className={`vu-chart-wrapper ${chartConfig?.isDrawing ? 'drawing-mode' : 'default-mode'}`}>
            <div
                id={'vu_chart_filters_' + vuId}
                className={`vu-chart-filters ${executeResult.filterList.length > 0 ? '' : 'hide'}`}
            >
                {executeResult.filterList.length > 0 && (
                    <FilterList
                        visualUnitId={vuId}
                        explore={'no'}
                        chartFilter={executeResult.filterList[0]}
                    />
                )}
            </div>
            <div
                id={'vu_chart_content_' + vuId}
                className="vu-chart-content"
                onMouseUp={() => {
                    if (!drawingActive.current && dragging.current) {
                        alpha.current = chartComponent.current?.chart.options.chart.options3d.alpha
                        beta.current = chartComponent.current?.chart.options.chart.options3d.beta
                    }
                    drawingActive.current = false
                    dragging.current = false
                }}
                onMouseDown={chartMouseDown}
                onMouseMove={chartMove}
                onMouseLeave={() => {
                    drawingActive.current = false
                    dragging.current = false
                }}
                ref={chartWidthRef}
            >
                {viewerType !== FoundationsEnums.VisualUnitViewerType.Table ? (
                    <HighchartsReact
                        containerProps={{ style: { height: '100%', width: '100%', cursor : currentUserData.privilege?.includes('AllowDrillThruLaunch') && AllowDrillThru == 'Y' ? 'pointer' : 'default'  } }}
                        ref={chartComponent}
                        highcharts={Highcharts}
                        options={chartOptions}
                        tabIndex={0}
                        immutable={!chartConfig.isDrawing && !chartConfig?.enable3dView}
                    />
                ) : (
                    <></>
                )}
            </div>
        </div>
    )
}

export default ReportChart
